module.exports = __webpack_public_path__ + "static/media/meenakshi.f5d53c7e.jpg";